module.exports = __webpack_public_path__ + "img/photo-2-2.bb75c8a8.jpg";